import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "@excalidraw/excalidraw/index.css";
import "./styles/reset.css";
import "./styles/styles.css";

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
